<template>
  <div class="h-100">
    <div v-if="mode !== 1" class="app-config-loader flex-column justify-content-center align-items-center d-flex">
      <BImg
        v-if="mode === 0 || mode === 2"
        src="/loading.gif"
        fluid
        alt="Responsive image"
        width="400"
        height="300"
      ></BImg>
      <BImg v-if="mode === 3" src="/500.svg" fluid alt="Responsive image" width="250" class="pb-5 mb-5"></BImg>
      <h5 class="text-muted loading-text">{{ modeMessage }}.</h5>
    </div>

    <router-view v-else />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { AppMode, AppModule } from "@/core/store/modules/app-module";
import { BImg } from "bootstrap-vue-next";

export default defineComponent({
  name: "App",
  components: {
    BImg
  },
  computed: {
    mode(): AppMode {
      return AppModule.mode;
    },
    modeMessage(): string {
      switch (this.mode) {
        case AppMode.Loading:
          return "Loading Application Configuration...";
        case AppMode.Ready:
          return "";
        case AppMode.LoggingOut:
          return "Logging Out...";
        case AppMode.Error:
          return "Error: " + AppModule.error;
        default:
          return "";
      }
    },
    error(): string {
      return AppModule.error;
    }
  }
});
</script>
<style lang="scss" scoped>
.app-config-loader {
  background-color: #fff;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
}

.loading-text {
  position: absolute;
  top: calc(50% + 50px);
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
